var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popupWrap",class:{ 'active' : _vm.openOrClose },on:{"click":_vm.dimmedClickHandler}},[_c('div',{ref:"contentWrap",staticClass:"contentWrap"},[_vm._t(_vm.crntObj.slotName)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }